export const SHEET_ANIMATION = {
	duration: 0.3,
	ease: [0.32, 0.72, 0, 1] as const,
} as const;
